export default "__VITE_ASSET__BrmDiApC__"